<template>
  <div>
    <form action="" @submit.prevent="handleSubmit" v-if="adDetails">
      <div class="form-group">
        <div>
          <input
            type="text"
            id="title"
            class="form-control"
            v-model="adDetails.title"
            placeholder="Enter Headline"
          />
          <p class="validation-error-message" v-if="validationErrors.title">
            {{ validationErrors.title[0] }}
          </p>
        </div>
        <label for="title">Headline:</label>
      </div>
      <div class="form-group">
        <div>
          <input
            type="text"
            id="description"
            class="form-control"
            v-model="adDetails.description"
            placeholder="Enter Ad Copy"
          />
          <p
            class="validation-error-message"
            v-if="validationErrors.description"
          >
            {{ validationErrors.description[0] }}
          </p>
        </div>
        <label for="description">Ad copy:</label>
      </div>
      <div class="form-group">
        <div>
          <input
            type="text"
            id="url"
            class="form-control"
            v-model="adDetails.destinationUrl"
            placeholder="Enter URL"
          />
          <p
            class="validation-error-message"
            v-if="validationErrors.destinationUrl"
          >
            {{ validationErrors.destinationUrl[0] }}
          </p>
        </div>
        <label for="url">URL:</label>
      </div>
      <div class="form-group">
        <div>
          <select
            id="campaignType"
            class="form-control"
            v-model="adDetails.campaignType"
          >

            <option :value="selectedValue">{{ selectedValue }}</option>
            <option v-for="option in campaignTypeSelection" :key="option" :value="option">
              {{ option }}
            </option>
          </select>
          <p
            class="validation-error-message"
            v-if="validationErrors.campaignType"
          >
            {{ validationErrors.campaignType[0] }}
          </p>
        </div>
        <label for="campaignType">Campaign Type:</label>
      </div>
      <div class="form-group">
        <div>
          <select
            id="ctaButtonText"
            class="form-control"
            v-model="adDetails.ctaButtonText"
          >
            <option value="">Select CTA Button Text</option>
            <option value="Get in touch">Get in touch</option>
            <option value="Find out more">Find out more</option>
            <option value="Request an appraisal">Request an appraisal</option>
            <option value="Contact us">Contact us</option>
            <option value="Learn more">Learn more</option>
          </select>
          <p
            class="validation-error-message"
            v-if="validationErrors.ctaButtonText"
          >
            {{ validationErrors.ctaButtonText[0] }}
          </p>
        </div>
        <label for="ctaButtonText">CTA Button Text:</label>
      </div>
      <div class="form-group">
        <div>
          <input
            type="text"
            id="targetPostcodes"
            class="form-control"
            v-model="adDetails.targetPostcodes"
            placeholder="Enter Target Post Codes"
          />
          <p
            class="validation-error-message"
            v-if="validationErrors.targetPostcodes"
          >
            {{ validationErrors.targetPostcodes[0] }}
          </p>
        </div>
        <label for="targetPostcodes">Target Post Codes:</label>
      </div>

      <div class="mt-5">
        <p style="text-transform: uppercase; font-weight: bold;">
          Key Image:
        </p>
        <div class="d-flex" style="flex-wrap: wrap;" v-if="adDetails.imageList">
          <div
            v-for="(image, index) in adDetails.imageList"
            :key="index"
            class="mr-4 mb-4"
          >
            <ImageGrid
              :imageUrl="image.url"
              :imageKey="image.position"
              :id="image.position"
              @on-image-updated="handleImageUpdated"
              :error="
                validationErrors.imageList && validationErrors.imageList[index]
                  ? validationErrors.imageList[index]
                  : null
              "
            ></ImageGrid>
          </div>
        </div>
        <div v-else>
          <p>No images available.</p>
        </div>
      </div>
      <div class="mt-4" v-if="videoUrl">
        <p style="text-transform: uppercase; font-weight: bold;">Video:</p>
        <div class="form-group" v-if="videoUrl">
          <div>
            <input
              type="text"
              class="form-control"
              :value="videoUrl"
              readonly
            />
          </div>
          <label>Current Video URL:</label>
        </div>
        <div class="row" style="margin-top: 10px" v-if="videoUrl">
          <div class="col-4">
            <video-upload
              :video="video"
              :displayLabel="false"
              :handleFileChange="handleVideoFileChange"
              ref="videoRef"
            />
          </div>
        </div>
        <div v-if="videoSizeError" style="color: red; font-size: 14px;">
          {{ VIDEO_ERROR_MESSAGES.MAX_SIZE }}
        </div>
        <div v-if="videoFileTypeError" style="color: red; font-size: 14px;">
          {{ VIDEO_ERROR_MESSAGES.FILE_TYPE }}
        </div>
        <p style="font-size: 12px;">MP4 only, max 1GB</p>
      </div>

      <button type="submit" class="btn btn-primary mt-3">
        Save Changes
      </button>
    </form>
    <app-modal-progress-bar
      v-if="progress['saveAdDetails'].visible"
      :progress="progress['saveAdDetails'].progress"
      :label="progress.label"
      :state="progress.state"
    ></app-modal-progress-bar>
    <app-modal-progress-bar
      :state="videoUploadProgress.state"
      :progress="videoUploadProgress.progress"
      :label="videoUploadProgress.label"
      :onCancel="onCancelVideoUpload"
      v-if="videoUploadProgress.visible"
    ></app-modal-progress-bar>
  </div>
</template>
<script>
import axios from 'axios';
import ImageGrid from './ImageGrid.vue';
import AppModalProgressBar from '../../AppComponents/Loaders/AppModalProgressBar.vue';
import VideoUpload from '../../../helpers/VideoUpload';
import CampaignServiceV2 from '../../../services/V2/CampaignServiceV2';
import ProgressState from '../../../mixins/ProgressState';
import {VIDEO_ERROR_MESSAGES, VIDEO_LIMITS} from '../../../configs/videoLimits';

export default {
  props: ['campaignId'],
  mixins: [ProgressState],
  components: {
    ImageGrid,
    AppModalProgressBar,
    VideoUpload,
  },
  created() {
    this.registerLoader('saveAdDetails');
  },
  mounted() {
    this.getCampaignAdListingDetails();
  },
  data() {
    return {
      adDetails: null,
      progress: {
        label: 'Saving ad listing details...',
        state: 'loading',
      },
      validationErrors: {},
      selectedValue: null,
      video: null,
      videoSizeError: false,
      videoFileTypeError: false,
      VIDEO_ERROR_MESSAGES: VIDEO_ERROR_MESSAGES,
      VIDEO_LIMITS: VIDEO_LIMITS,
      videoUploadProgress: {
        progress: 0,
        visible: false,
        label: 'Uploading your video, please wait...',
        state: 'loading',
      },
      videoUploadController: null,
      videoUrl: null,
    };
  },
  computed: {
    campaignTypeSelection() {
      let array = ['Branding Campaign', 'Recruitment Campaign', 'Property Management'];
      return array.filter(item => item !== this.selectedValue);
    }
  },
  methods: {
    getCampaignAdListingDetails() {
      CampaignServiceV2.getCampaignAdListingDetails(this.campaignId).then(
        (response) => {
          this.adDetails = response.data.data;
          this.selectedValue = this.adDetails.campaignType;
          this.videoUrl = this.adDetails.videoUrl || null;
        }
      );
    },
    handleImageUpdated(data) {
      this.handleImageListItemUpdated(data);
    },
    handleImageListItemUpdated(data) {
      this.adDetails.imageList = this.adDetails.imageList.map((img) => {
        if (img.position === data.imageKey) {
          img.url = data.imageUrl;
        }
        return img;
      });
    },
    validateVideo() {
      this.videoSizeError = false;
      this.videoFileTypeError = false;

      if (!(this.video instanceof File)) return true;

      if (this.video.size > VIDEO_LIMITS.MAX_SIZE) {
        this.videoSizeError = true;
        return false;
      }

      if (
        this.video.type !== 'video/mp4' ||
        !this.video.name.toLowerCase().endsWith('.mp4')
      ) {
        this.videoFileTypeError = true;
        return false;
      }

      return true;
    },
    onCancelVideoUpload() {
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }
      this.videoUploadProgress.visible = false;
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.label = 'Uploading your video, please wait...';
      this.video = null;
      this.videoUrl = null;
      if (this.$refs.videoRef) {
        this.$refs.videoRef.clearVideo();
      }
    },
    async handleVideoFileChange(file) {
      if (this.videoUploadController) {
        this.videoUploadController.abort();
        this.videoUploadController = null;
      }

      this.videoUploadController = new AbortController();
      this.video = file;

      if (!this.validateVideo()) {
        this.videoUploadController = null;
        return;
      }

      this.videoSizeError = false;
      this.videoFileTypeError = false;
      this.videoUploadProgress.visible = true;
      this.videoUploadProgress.state = 'loading';
      this.videoUploadProgress.progress = 0;
      this.videoUploadProgress.label = 'Uploading your video, please wait...';

      try {
        const presignedData = await CampaignServiceV2.getUploadPresignedUrl(file.name);

        await CampaignServiceV2.uploadBinaryToPresignedUrl(
          presignedData.data.url,
          file,
          (progress) => {
            if (progress < 95) this.videoUploadProgress.progress = progress;
          },
          this.videoUploadController
        );

        await CampaignServiceV2.registerVideo({
          filename: presignedData.data.filename,
        });

        const rawUrl = presignedData.data.url;
        const mp4Index = rawUrl.indexOf('.mp4');
        this.videoUrl = mp4Index !== -1 ? rawUrl.substring(0, mp4Index + 4) : rawUrl;
        this.videoUploadProgress.progress = 100;
        this.videoUploadProgress.state = 'loaded';
        this.videoUploadProgress.label = 'Video upload successful.';
      } catch (error) {
        if (
          error.name === 'AbortError' ||
          error.message.includes('aborted') ||
          error.code === 'ERR_CANCELED' ||
          axios.isCancel(error) ||
          error.message.includes('cancelled') ||
          error.message === 'Upload cancelled by user'
        ) {
          this.videoUploadProgress.state = 'cancelled';
          this.videoUploadProgress.label = 'Video upload cancelled.';
          setTimeout(() => {
            this.videoUploadProgress.visible = false;
          }, 1000);
          return;
        }

        this.video = null;
        this.$refs.videoRef.clearVideo();
        this.videoUploadProgress.state = 'error';
        this.videoUploadProgress.label = 'Video upload failed. Please try again.';
        setTimeout(() => {
          this.$refs.videoRef.clearVideo();
        }, 2000);
      } finally {
        if (this.videoUploadController) {
          this.videoUploadController = null;
        }
        setTimeout(() => {
          if (this.videoUploadProgress.state !== 'cancelled') {
            this.videoUploadProgress.visible = false;
          }
        }, 2000);
      }
    },
    handleSubmit() {
      this.startProgress('saveAdDetails');
      this.progress.state = 'loading';
      this.progress.label = 'Saving ad listing details...';
      this.validationErrors = {};
      const formattedAdDetails = {
        ...this.adDetails,
        ...(this.videoUrl ? {videoUrl: this.videoUrl} : {}),
      };

      CampaignServiceV2.updateCampaignAdListingDetails(
        this.campaignId,
        formattedAdDetails
      )
        .then(() => {
          this.endProgress('saveAdDetails');
          this.progress.label = 'Ad listing details saved successfully!';
          this.getCampaignAdListingDetails();
          setTimeout(() => {
            this.closeProgress('saveAdDetails');
          }, 1000);
        })
        .catch((error) => {
          const status = error.response.status;

          if (status === 422) {
            this.validationErrors = error.response.data.errors;

            // Check if any imageList validation errors exist
            const hasImageListErrors = Object.keys(this.validationErrors).some(
              (key) => key.startsWith('imageList.')
            );
            if (hasImageListErrors) {
              this.validationErrors.imageList = Object.keys(
                this.validationErrors
              )
                .filter((key) => key.startsWith('imageList.'))
                .reduce((acc, key) => {
                  const formattedKey = key.split('.')[1];
                  acc[formattedKey] = this.validationErrors[key][0];
                  return acc;
                }, {});
            }

            this.progress.label =
              'Validation error encountered, please review the form.';
          } else {
            this.progress.label =
              'Error saving ad listing details. Please try again.';
          }

          this.progress.state = 'error';
          this.endProgress('saveAdDetails');
          setTimeout(() => {
            this.closeProgress('saveAdDetails');
          }, 3000);
        });
    },
  },
};
</script>

<style scoped>
.validation-error-message {
  font-size: 14px;
  color: red;
}
</style>
